// Moment
import moment from 'moment';

export const formatedDateChat = (date) => {
  const mDate = moment.utc(date).local();
  const today = mDate.isSame(moment(), 'day');
  return today ? mDate.format('hh:mm a') : mDate.format('DD/MM/YY, hh:mm a');
};

export const dummyId = () => {
  const hexaChars = '0123456789abcdef';
  let id = '';

  for (let i = 0; i < 24; i++) {
    const randomIndex = Math.floor(Math.random() * hexaChars.length);
    id += hexaChars.charAt(randomIndex);
  }

  return id;
};
